export function reformatCatsData(data){
    


    let formated=[];

   for(const i in data){
     formated.push(
     {
       name:i,
       donut_series:[data[i].offline,data[i].stopped,data[i].working],
       donut_labels:['offline','stopped','working'],

       series_data:[
        {
          name:"Total",
         data: getSeries(data[i].types,'total')
        },
         {
            name:"Working",
            data: getSeries(data[i].types,'working')
          },
       ],
       labels: getSeries(data[i].types,'name')
       }
     
     )
   }

  // formated_data=formated;
//console.log(formated)


   return formated;

 }

  //dataFormater(categories_data.value)
 const getSeries=(rawdata,colName)=>{
     let  out =[];
   rawdata.forEach(element => {
       out.push(element[colName])
    });


 return out;

}



export function  reFormatDevicesData(data){



    return [
       {
           icon: 'LayersIcon',
           color: 'light-primary',
           title: data.Total.count,
           subtitle: 'Total',
           subtitle_label: 'Total Devices',
           tip_text:"The count of Total Devices for current user",
           customClass: 'mb-1 mb-xl-0 ddata',
           list:data.Total.list,

           fields:[{key:'id','label':'id'},{key: 'name', label: 'name'},{ key: 'group', label: 'group', sortable: true },]
         },
         {
             icon: 'CheckCircleIcon',
             color: 'light-primary',
             title: data.Working.count,
             subtitle: 'Working',
             subtitle_label:"Working Engine",
             tip_text:"The count of  Devices Engin now is runing",
             customClass: 'mb-1 mb-xl-0 ddata',
             list:data.Working.list,
             fields:[{key:'id','label':'id'},{key: 'name', label: 'name'},{ key: 'group', label: 'group', sortable: true },]
           },
           {
             icon: 'AlertOctagonIcon',
             color: 'light-danger',
             title: data.Stopped.count,
             subtitle: 'Stopped',
             subtitle_label:"Stopped Engine",
             tip_text:"The count of current stoped engin",
             customClass: 'mb-1 mb-sm-0 ddata',
             list:data.Stopped.list,
             fields:[{key:'id','label':'id'},{key: 'name', label: 'name'},{ key: 'group', label: 'group', sortable: true },]
           },
           {
             icon: 'TruckIcon',
             color: 'light-primary',
             title: data.Moving.count,
             subtitle: 'Moving',
             subtitle_label:"Moving Devices",
             tip_text:"The count of current movig devices",
             customClass: 'mb-1 mb-sm-0 ddata',
             list:data.Moving.list,
             fields:[{key:'id','label':'id'},{key: 'name', label: 'name'},{ key: 'group', label: 'group', sortable: true },]
           },
   
           {
             icon: 'PauseCircleIcon',
             color: 'light-secondary',
             title: data.Idle.count,
             subtitle: 'Idle',
             subtitle_label:"Idle Devices",
             tip_text:'The count of current engin is work but no moving',
             customClass: 'mb-1 mb-sm-0 ddata',
             list:data.Idle.list,
             fields:[{key:'id','label':'id'},{key: 'name', label: 'name'},{ key: 'group', label: 'group', sortable: true },]
           },
          //  {
          //    icon: 'XIcon',
          //    color: 'light-danger',
          //    title: data.Absent.count,
          //    subtitle:  "Absent",
          //    subtitle_label:"Absent Devices",
          //    tip_text:'The count of devices not attended to work',
          //    customClass: 'mb-1 mb-sm-0 ddata',
          //    list:data.Absent.list,
          //     fields:[{key:'id','label':'id'},{key: 'name', label: 'name'},{ key: 'group', label: 'group', sortable: true },]
          //  },
           {
            icon: 'WifiOffIcon',
            color: 'light-danger',
            title: data.Offline.count,
            subtitle: 'Offline',
            subtitle_label:"Offline Devices",
            tip_text:'The count of not connceted devices to net work',
            customClass: 'mb-1 mb-sm-0 ddata',
            list: data.Offline.list,
            fields:[{key:'id','label':'id'},{key: 'name', label: 'name'},{ key: 'group', label: 'group', sortable: true },]
          },
   
   ]
    
       
   }

export function  reFormatGardenData(data){
   let current_data=[];
   current_data=data;
  let planedData=[];
  let servedData=[];
  let labelData=[];
  let  list=[];
  let out=[]

  labelData=[];
    
  



  for(const i in current_data){

  planedData.push(current_data[i].planned)
  servedData.push(current_data[i].served)
  labelData.push(current_data[i].name)
  list.push(current_data[i].list)


  }



   out.push({
    labels_data:labelData,
    series_data:[
      {
       name:"Planed",
       data:planedData
      },
       {
          name:"Served",
          data: servedData
        },

    ],
    listOfData:list


   })
   

  return out[0];





}
